import "./Payment.css";

import { AppPaymentLinksModel, PaymentLinksModel } from "../../../models/paymentLinksModel";
import { faArrowCircleLeft, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { getPaymentLinks, sendReceipt } from "../../../api/infringement";
import { mobileMethods, webMethods } from "../../../paymentMethodThumbnails";
import { useEffect, useRef, useState } from "react";

import Absa from "../../../assets/images/absa.svg";
import Capitec from "../../../assets/images/capitec.svg";
import CustomInput from "../../CustomInput/CustomInput";
import FNB from "../../../assets/images/fnb.svg";
import FNBPayLogo from "../../../assets/images/FNB_Pay_logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MasterpassLogo from "../../../assets/images/mc_symbol.svg";
import NedbankMoneyLogo from "../../../assets/images/nedbank-money.svg";
import PaymentMethod from "../../PaymentMethod/PaymentMethod";
import QRCode from "react-qr-code";
import RMBLogo from "../../../assets/images/rmb.svg";
import ReactLoading from "react-loading";
import ResponseModel from "../../../models/responseModel";
import ScanToPay from "../../../assets/images/scan-to-pay.png";
import SnapScanLogo from "../../../assets/images/snapscan.svg";
import Zapper from "../../../assets/images/zapper.svg";
import { useAppSelector } from "../../../hooks/reduxHooks";

const Payment = () => {
  const [receiptEmail, setReceiptEmail] = useState<string>();
  const [emailSubmitted, setEmailSubmitted] = useState<boolean>(false);
  const [scanToPayOpen, setScanToPayOpen] = useState<boolean>(false);
  const [links, setLinks] = useState<PaymentLinksModel | null>(null);
  const infringement = useAppSelector((state) => state.fine.infringement);
  const account = useAppSelector((state) => state.fine.account);
  const user = useAppSelector((state) => state.auth.user);

  const [selectedLink, setSelectedLink] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [qrAppLogos, setQRAppLogos] = useState<any>([]);
  const [supportedApplications, setSupportedApplications] = useState<any>([]);

  const [emailError, setEmailError] = useState<string | null>(null);

  const acceptGuilt = useAppSelector((state) => state.guilt.acceptGuilt);
  const acceptTerms = useAppSelector((state) => state.guilt.acceptTerms);
  const [iframeLoading, setIFrameLoading] = useState<boolean>(false);

  const [intermediaryScreenVisible, setIntermediaryScreenVisible] = useState<boolean>(false);

  useEffect(() => {
    if (!user) getLinks();
    window.addEventListener("message", (event) => {
      if (event.data === "onClose" && event.origin.startsWith("https://payat.io")) {
        setIFrameLoading(false);
        setSelectedLink(false);
      }
    });
    window.addEventListener("message", (event) => {
      if (event.data === "onLoad" && event.origin.startsWith("https://payat.io")) {
        setIFrameLoading(false);
        setLoading(false);
      }
    });
  }, []);

  useEffect(() => {
    if (user) getLinks();
  }, [user]);

  useEffect(() => {
    if (supportedApplications && supportedApplications?.length > 0) {
      displayQRAppLogos();
    }
  }, [supportedApplications]);

  const displayQRAppLogos = () => {
    if (supportedApplications!?.length > 0) {
      supportedApplications?.map((app: string) => {
        switch (app.toLowerCase()) {
          case "snapscan":
            setQRAppLogos((qrAppLogos: any) => [
              ...qrAppLogos,
              { logo: SnapScanLogo, title: "Snapscan" },
            ]);
            break;
          case "zapper":
            setQRAppLogos((qrAppLogos: any) => [...qrAppLogos, { logo: Zapper, title: "Zapper" }]);
            break;
          case "masterpass":
            setQRAppLogos((qrAppLogos: any) => [
              ...qrAppLogos,
              { logo: MasterpassLogo, title: "Masterpass" },
            ]);
            break;
          case "nedbank_money":
            setQRAppLogos((qrAppLogos: any) => [
              ...qrAppLogos,
              { logo: NedbankMoneyLogo, title: "Nedbank" },
            ]);
            break;
          case "fnb_scan_to_pay":
            setQRAppLogos((qrAppLogos: any) => [...qrAppLogos, { logo: FNBPayLogo, title: "FNB" }]);
            break;
          case "rmb_scan_to_pay":
            setQRAppLogos((qrAppLogos: any) => [...qrAppLogos, { logo: RMBLogo, title: "RMB" }]);
            break;

          default:
            break;
        }
      });
    }
  };

  const getLinks = async () => {
    setLoading(true);
    setLinks(null);
    getPaymentLinks(account!, infringement?.amount!, acceptGuilt, acceptTerms)
      .then((resp: any) => {
        if (resp.status) {
          const webPaymentLinks = resp.data.webPaymentLinks;
          let appPaymentLinks = webPaymentLinks.concat(resp.data.appPaymentLinks);
          let fnbPresent = appPaymentLinks?.some(
            (link: AppPaymentLinksModel) => link.paymentMethodName === "FNB_SCAN_TO_PAY"
          );
          if (fnbPresent) {
            const rmbObj = {
              paymentMethodName: "RMB_SCAN_TO_PAY",
              paymentUrl: appPaymentLinks.filter(
                (link: AppPaymentLinksModel) => link.paymentMethodName === "FNB_SCAN_TO_PAY"
              )[0].paymentUrl,
            };
            appPaymentLinks = appPaymentLinks.concat(rmbObj);
          }

          const qrCodePayment = resp.data.qrCodePayment;
          const messageId = resp.data.messageId;
          const transmissionDateTime = resp.data.transmissionDateTime;
          const referenceKey = resp.data.referenceKey;
          if (referenceKey) {
            localStorage.setItem("referenceKey", referenceKey);
          }
          setLinks({
            messageId: messageId,
            transmissionDateTime: transmissionDateTime,
            referenceKey: referenceKey,
            webPaymentLinks: webPaymentLinks,
            appPaymentLinks: appPaymentLinks,
            qrCodePayment: qrCodePayment,
          });
          setSupportedApplications(resp.data.qrCodePayment.supportedApplications);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (links && selectedLink && window.innerWidth <= 480) {
      if (selectedLink.name !== "EFT" && selectedLink.name !== "CARD") {
        setIntermediaryScreenVisible(true);
      } else {
        setIFrameLoading(true);
      }
    } else if (selectedLink) {
      setIFrameLoading(true);
    }
  }, [selectedLink]);

  const submitEmail = () => {
    setEmailError(null);
    if (receiptEmail) {
      sendReceipt(infringement?.noticeNumber!, receiptEmail).then(
        ({ status, errors }: ResponseModel) => {
          if (status) {
            setEmailSubmitted(true);
          } else {
            setEmailError(errors.email[0]);
          }
        }
      );
    } else {
      setEmailError("Please enter an email address");
    }
  };

  const getAppBackground = (name: string) => {
    switch (name.toLowerCase().replace(/\_/g, " ")) {
      case "card":
        return { backgroundColor: "#406475", color: "white" };
      case "eft":
        return {
          backgroundColor: "white",
          color: "#003750",
        };
      case "snapscan":
        return { backgroundColor: "#3B77BC", color: "white" };
      case "zapper":
        return { backgroundColor: "#005cb9", color: "white" };
      case "masterpass":
        return { backgroundColor: "#19272B", color: "white" };
      case "nedbank money":
        return { backgroundColor: "#026341", color: "white" };
      case "fnb scan to pay":
        return { backgroundColor: "#05A9AC", color: "white" };
      case "rmb scan to pay":
        return { backgroundColor: "white", color: "#003750" };
      case "nedbank scan to pay":
        return { backgroundColor: "#026341", color: "white" };
      case "capitec eft":
        return { backgroundColor: "white", color: "#003750" };

      default:
        return { backgroundColor: "#446D7F", color: "white" };
    }
  };

  return (
    <>
      {iframeLoading && (
        <>
          <div
            className="register-overlay"
            style={{ zIndex: 2, height: "110vh", marginTop: "-12%" }}
          />
          <div
            style={{
              position: "absolute",
              marginTop: "30vh",
              marginLeft: "48vw",
              zIndex: 3,
            }}
          >
            <ReactLoading type="bubbles" color="#e97700" />
          </div>
        </>
      )}
      <div
        className="payment-modal"
        style={{
          visibility:
            selectedLink &&
            (window.innerWidth > 480 || selectedLink.name === "CARD" || selectedLink.name === "EFT")
              ? "visible"
              : "hidden",
        }}
      >
        <iframe
          src={selectedLink?.link!}
          style={{ width: "100%", height: "100%", border: "none" }}
          id="payment-modal"
          ref={iframeRef}
          sandbox="allow-forms allow-scripts allow-same-origin allow-top-navigation allow-top-navigation-by-user-activation"
        ></iframe>
      </div>

      <div className="step-container">
        <p className="step-title">Please choose how you would like to complete the payment</p>
        <br />
        <div className="step-two-content">
          <div className="payment-details-container">
            <p className="container-title">Payment Details:</p>
            <div className="total-due-container">
              <p>Total Due:</p>
              <p>{`R${infringement!.amount / 100}`}</p>
            </div>
          </div>
          <div className="vertical-divider" />
          {!scanToPayOpen ? (
            <>
              <div className="payment-methods-container" style={{ minHeight: 400 }}>
                <span className="container-title" style={{ whiteSpace: "nowrap" }}>
                  Payment Options:
                  <div
                    style={{
                      marginLeft: "5%",
                      marginBottom: -8,
                      width: "100%",
                      visibility: loading ? "visible" : "hidden",
                    }}
                  >
                    <ReactLoading type="bubbles" color="#e97700" height={"5%"} width={"10%"} />
                  </div>
                  {/* )} */}
                </span>

                <div className="payment-methods-list" style={{ minHeight: 350 }}>
                  {!links?.webPaymentLinks && !loading && (
                    <p className="empty-payment-list" style={{ marginTop: "15%" }}>
                      Unable to load payment links at this time
                    </p>
                  )}
                  {links?.webPaymentLinks
                    ?.filter((e: any) => !e.paymentMethodName.toLowerCase().includes("test"))
                    .map((method: any, index: number) => {
                      return (
                        <PaymentMethod
                          link={method.paymentUrl}
                          setLink={(link: any) => setSelectedLink(link)}
                          key={index}
                          name={method.paymentMethodName}
                          images={
                            webMethods.filter((e) =>
                              e.name
                                .toLowerCase()
                                .includes(String(method.paymentMethodName).toLowerCase().trim())
                            )[0]?.thumbnails ||
                            webMethods.filter((e) =>
                              method.paymentMethodName
                                .toLowerCase()
                                .includes(String(e.name).toLowerCase().trim())
                            )[0]?.thumbnails
                          }
                        />
                      );
                    })}

                  {links?.qrCodePayment && (
                    <PaymentMethod
                      link={links?.qrCodePayment?.qrCodeUrl}
                      name="Scan To Pay"
                      isQR
                      images={[ScanToPay]}
                      setScanToPayOpened={setScanToPayOpen}
                    />
                  )}
                </div>
              </div>
            </>
          ) : (
            <div className="payment-methods-container" style={{ minHeight: user ? "auto" : 400 }}>
              <span className="container-title">
                <FontAwesomeIcon
                  className="back-button"
                  icon={faArrowCircleLeft}
                  size="3x"
                  color="#18283c"
                  onClick={() => setScanToPayOpen(false)}
                />
                Scan to pay
              </span>

              <div className="payment-methods-list" style={{ minHeight: user ? "auto" : 350 }}>
                <div className="qr-container">
                  <p>
                    To pay with Scan to Pay, open the relevant app on your mobile and scan the QR
                    code below.
                  </p>
                  <p>
                    <b>Please note that payment will continue externally on the relevant app.</b>
                  </p>
                  <div className="qr-code-container">
                    {links?.qrCodePayment.qrCodeUrl ? (
                      <QRCode value={links?.qrCodePayment.qrCodeUrl!} size={120} />
                    ) : null}

                    <div className="supported-applications">
                      <div className="snap-option">
                        <img className="app-logo" src={Absa} />
                        <p>ABSA</p>
                      </div>
                      <div className="snap-option">
                        <img className="app-logo" src={Capitec} />
                        <p>Capitec</p>
                      </div>
                      <div className="snap-option">
                        <img className="app-logo" src={FNB} />
                        <p>FNB</p>
                      </div>
                      <div className="snap-option">
                        <img className="app-logo" src={MasterpassLogo} />
                        <p>MasterPass</p>
                      </div>
                      <div className="snap-option">
                        <img className="app-logo" src={NedbankMoneyLogo} />
                        <p>Nedbank</p>
                      </div>
                      <div className="snap-option">
                        <img className="app-logo" src={RMBLogo} />
                        <p>RMB</p>
                      </div>
                      <div className="snap-option">
                        <img className="app-logo" src={SnapScanLogo} />
                        <p>SnapScan</p>
                      </div>

                      <div className="snap-option">
                        <img className="app-logo" src={Zapper} />
                        <p>Zapper</p>
                      </div>
                    </div>
                  </div>
                  {!user ? (
                    <div>
                      <br />
                      <hr />
                      <br />
                      <div className="receipt-container">
                        {!emailSubmitted ? (
                          <>
                            <p className="receipt-heading">
                              Would you like to receive a receipt once we’ve verified the payment?
                            </p>

                            <CustomInput
                              label="EMAIL ADDRESS"
                              placeholder="Email Address"
                              value={receiptEmail}
                              setValue={setReceiptEmail}
                            />
                            {emailError && <p className="error-text">{emailError}</p>}
                            <div className="save-address" onClick={() => submitEmail()}>
                              Submit
                            </div>
                          </>
                        ) : (
                          <>
                            <p className="receipt-heading" style={{ marginTop: 15 }}>
                              On verifying a successful payment, we’ll send your receipt to you.
                            </p>
                            <p className="receipt-subheading" style={{ marginTop: 5 }}>
                              Kindly note this can take up to 36 hours.
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  ) : (
                    <>
                      <br />
                      <p style={{ fontWeight: 700 }}>
                        On verifying a successful payment, we’ll send your receipt and associated
                        warrant documents to the email address linked to your account.
                      </p>
                      <p>Kindly note this can take up to 36 hours.</p>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        {/* mobile */}
        <div className="total-due-container-mobile">
          <p>Total Due:</p>
          <p>R{infringement?.amount! / 100}</p>
        </div>

        <div className="please-choose-text">
          <p
            style={{
              display: intermediaryScreenVisible ? "none" : "flex",
              marginRight: "5%",
            }}
          >
            Payment Options:
          </p>

          {loading && !selectedLink && (
            <ReactLoading type="bubbles" color="#e97700" height={"10%"} width={"6%"} />
          )}
        </div>
        <div className="mobile-payment-options-container">
          {!links?.appPaymentLinks && !loading && (
            <p className="empty-payment-list">Unable to load payment links at this time</p>
          )}
          {!intermediaryScreenVisible ? (
            links?.appPaymentLinks
              ?.filter((e: any) => !e.paymentMethodName.toLowerCase().includes("test"))
              .map((appLink: any, index: number) => {
                let image: any;
                try {
                  image = mobileMethods.filter(
                    (e) =>
                      e.name.toLowerCase() ===
                      String(appLink.paymentMethodName.replace(/\_/g, " ")).toLowerCase()
                  )[0]?.thumbnails![0];
                } catch (e) {
                  console.log(e);
                }
                return (
                  <div
                    className="mobile-payment-option"
                    style={getAppBackground(appLink.paymentMethodName)}
                    onClick={() =>
                      setSelectedLink({
                        image: image,
                        name: appLink.paymentMethodName,
                        link: appLink.paymentUrl,
                      })
                    }
                    key={index}
                  >
                    {image && <img className="mobile-payment-image" src={image} alt="" />}

                    <p>
                      {appLink.paymentMethodName === "MASTERPASS"
                        ? "SCAN TO PAY"
                        : appLink.paymentMethodName === "EFT"
                        ? "INSTANT EFT"
                        : appLink.paymentMethodName === "NEDBANK_MONEY"
                        ? "NEDBANK"
                        : appLink.paymentMethodName === "FNB_SCAN_TO_PAY"
                        ? "FNB"
                        : appLink.paymentMethodName === "RMB_SCAN_TO_PAY"
                        ? "RMB"
                        : appLink.paymentMethodName === "CAPITEC_EFT"
                        ? "CAPITEC PAY"
                        : appLink.paymentMethodName.replace(/\_/g, " ")}
                    </p>
                  </div>
                );
              })
          ) : (
            <div className="intermediary-screen">
              <span
                className="change-payment-method"
                onClick={() => {
                  setIntermediaryScreenVisible(false);
                  setSelectedLink(null);
                }}
              >
                <FontAwesomeIcon icon={faArrowLeft} size="2x" color="#18283c" />
                Change Payment Method
              </span>
              {/* {selectedLink.image ? <img src={selectedLink.image} /> : null} */}
              <p className="intermediary-heading">{selectedLink.name.replace(/\_/g, " ")}</p>
              <p className="intermediary-subheading">
                Please note that payment will continue externally on the{" "}
                {selectedLink.name.replace(/\_/g, " ")} app.
              </p>
              {user ? (
                <>
                  <p className="intermediary-description">
                    On verifying a successful payment, we’ll send your receipt
                    {infringement?.warrantOfArrestPending
                      ? " and associated warrant documents "
                      : ""}{" "}
                    to {user.email}.{" "}
                  </p>
                  <p className="intermediary-disclaimer">
                    Kindly note this can take up to 36 hours.
                  </p>
                  <div
                    className="continue-to-button"
                    onClick={() => window.open(selectedLink?.link!)}
                  >
                    CONTINUE TO {selectedLink.name.replace(/\_/g, " ")}
                  </div>
                </>
              ) : !emailSubmitted ? (
                <>
                  <div className="receipt-container" style={{ height: "auto" }}>
                    <p className="receipt-heading">
                      Would you like to receive a receipt once we’ve verified the payment?
                    </p>

                    <CustomInput
                      label="EMAIL ADDRESS"
                      placeholder="Email Address"
                      value={receiptEmail}
                      setValue={setReceiptEmail}
                      containerStyle={{ width: "100%" }}
                    />
                    {emailError && <p className="error-text">{emailError}</p>}
                  </div>
                  {receiptEmail && receiptEmail?.length > 0 && !emailSubmitted ? (
                    <div className="continue-to-button" onClick={() => submitEmail()}>
                      Submit
                    </div>
                  ) : (
                    <div
                      className="continue-to-button"
                      onClick={() => window.open(selectedLink?.link!)}
                    >
                      CONTINUE TO {selectedLink.name.replace(/\_/g, " ")}
                    </div>
                  )}
                </>
              ) : (
                <>
                  <p className="receipt-heading" style={{ marginTop: 15 }}>
                    On verifying a successful payment, we’ll send your receipt{" "}
                    {infringement?.warrantOfArrestPending
                      ? "and associated warrant documents "
                      : ""}
                    to {receiptEmail}.
                  </p>
                  <p className="receipt-subheading" style={{ marginTop: 5 }}>
                    Kindly note this can take up to 36 hours.
                  </p>
                  <div
                    className="continue-to-button"
                    onClick={() => window.open(selectedLink?.link!)}
                  >
                    CONTINUE TO {selectedLink.name.replace(/\_/g, " ")}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Payment;
